/*
 * ob-subscription — selecteur achat unique / abonnement
 * ----------------------------------------------------
 * Le widget ne parle jamais a Recharge. Il place l'identifiant du plan dans
 * le champ selling_plan du formulaire produit ; Shopify cree le contrat au
 * paiement et Recharge prend la main ensuite.
 *
 * L'abonnement est preselectionne a l'arrivee : les prix montrent la remise
 * et le produit peut etre ajoute au panier directement, sans clic de plus.
 * Le client peut basculer sur « Une seule fois », ce qui retablit le tarif
 * plein. Le verrou cooperatif data-tt-block-obsub ne s'active que si aucun
 * mode n'est selectionne (etat qui ne se produit pas au chargement, mais sert
 * de garde-fou) ; les verrous des autres blocs (champ pseudo...) restent
 * respectes.
 *
 * Frequence mise en avant : quand le prix du pack choisi depasse le seuil
 * data-monthly-from (en centimes), « Chaque mois » passe a gauche et devient
 * la frequence preselectionnee ; sinon « Chaque semaine » reste en premier.
 * Des que le client clique lui-meme sur une frequence, on ne la change plus.
 *
 * Charge en defer : l'initialisation se fait donc apres l'analyse complete du
 * document, quand le formulaire et son bouton existent.
 */
(function () {
  var SELECTOR = '[data-ob-sub]';

  function init(root) {
    if (root.dataset.obInit === '1') return;
    root.dataset.obInit = '1';

    var form = document.getElementById(root.dataset.formId);
    if (!form) form = root.closest('form[action*="/cart/add"]');

    var planInput = root.querySelector('[data-ob-plan-input]');
    var freqWrap = root.querySelector('[data-ob-freq]');
    var freqOpts = root.querySelector('.ob-sub__freq-opts');
    var buyWrap = document.querySelector('[data-tt-buy]');

    var plans = { week: root.dataset.planWeek || '', month: root.dataset.planMonth || '' };
    var currency = root.dataset.currency || 'EUR';

    var prices = {};
    try {
      var raw = root.querySelector('[data-ob-prices]');
      if (raw) prices = JSON.parse(raw.textContent);
    } catch (e) {}

    // L'abonnement est preselectionne au chargement : les prix affichent la
    // remise et l'offre est prete a etre ajoutee au panier sans clic
    // supplementaire. Le client reste libre de basculer sur « Une seule fois »,
    // ce qui retablit alors le tarif plein.
    var mode = 'sub';
    var freq = plans.week ? 'week' : 'month';
    var freqTouched = false;
    var monthlyFrom = parseInt(root.dataset.monthlyFrom, 10);

    function money(cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency', currency: currency
        }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2) + ' ' + currency;
      }
    }

    // Reecrit un montant en calquant la mise en forme d'un prix deja affiche :
    // meme symbole, meme place, meme separateur decimal. Evite d'avoir
    // "EUR21,99" d'un cote et "17,59 EUR" de l'autre.
    function moneyLike(sample, cents) {
      if (!sample) return money(cents);
      var m = sample.match(/\d[\d\s.,\u00a0]*/);
      if (!m) return money(cents);
      // Le motif happe l'espace qui separe le nombre du symbole (« 89,99 € ») :
      // on le laisse en place, sinon on obtenait « 71,99€ ».
      var num = m[0].replace(/[\s\u00a0]+$/, '');
      var dec = sample.lastIndexOf(',') > sample.lastIndexOf('.') ? ',' : '.';
      return sample.replace(num, (cents / 100).toFixed(2).replace('.', dec));
    }

    // Remplit un modele traduit (« Puis %A chaque mois… »).
    function fill(tpl, amount) {
      return tpl ? tpl.replace('%A', amount) : '';
    }

    var tplRecur = { week: root.dataset.tplRecurWeek || '', month: root.dataset.tplRecurMonth || '' };
    var lblPer = { week: root.dataset.lblPerWeek || '', month: root.dataset.lblPerMonth || '' };

    var PRICE_SEL = '.tt-variants__price, .tt-packs__price';

    // Repercute la remise sur les cartes de packs. On memorise le prix
    // d'origine pour pouvoir le restaurer en achat unique.
    function syncCardPrices() {
      document.querySelectorAll('[data-tt-variant][data-variant-id]').forEach(function (card) {
        var el = card.querySelector(PRICE_SEL);
        if (!el) return;
        if (!el.hasAttribute('data-ob-orig')) {
          el.setAttribute('data-ob-orig', el.textContent.trim());
        }
        var orig = el.getAttribute('data-ob-orig');
        var v = prices[card.getAttribute('data-variant-id')];
        var pid = pricingPlanId();
        if (mode !== 'once' && v && pid && v[pid] != null) {
          // Ancien prix barre, puis prix d'abonnement. On construit les noeuds
          // plutot que d'injecter du HTML : le texte vient de la page.
          el.textContent = '';
          var was = document.createElement('s');
          was.className = 'ob-sub__was';
          was.textContent = orig;
          var now = document.createElement('span');
          now.className = 'ob-sub__now';
          now.textContent = moneyLike(orig, v[pid]);
          el.appendChild(was);
          el.appendChild(document.createTextNode(' '));
          el.appendChild(now);
          card.classList.add('is-ob-sub-price');
        } else {
          el.textContent = orig;
          card.classList.remove('is-ob-sub-price');
        }
      });
    }

    // Montant affiche pour le pack choisi, calque sur la mise en forme de sa carte.
    function priceSample() {
      var card = document.querySelector('[data-tt-variant][data-variant-id="' + variantId() + '"]');
      var el = card && card.querySelector(PRICE_SEL);
      return el ? (el.getAttribute('data-ob-orig') || el.textContent.trim()) : '';
    }

    // Mention de recurrence sous le bouton d'achat, masquee en achat unique.
    function syncSavings() {
      var v = prices[variantId()];
      var planId = plans[freq];
      var sub = v && planId && v[planId] != null ? v[planId] : null;
      var sample = priceSample();

      var recur = document.querySelector('[data-ob-recur]');
      if (recur) {
        if (mode === 'sub' && sub != null && tplRecur[freq]) {
          recur.textContent = fill(tplRecur[freq], moneyLike(sample, sub));
          recur.hidden = false;
        } else {
          recur.textContent = '';
          recur.hidden = true;
        }
      }

      // Periodicite lue par la barre d'achat mobile, a cote du prix.
      if (buyWrap) {
        if (mode === 'sub' && lblPer[freq]) buyWrap.setAttribute('data-ob-sub-per', lblPer[freq]);
        else buyWrap.removeAttribute('data-ob-sub-per');
      }
    }

    // Le selecteur de packs met a jour l'URL et le bouton radio, mais pas
    // toujours le champ cache name="id", qui peut rester sur la variante
    // precedente. On lit donc dans le meme ordre que le script du bouton
    // d'achat : URL, puis radio coche, puis champ cache en dernier recours.
    function variantId() {
      // Le bouton radio coche est la seule source fiable : le theme fige le
      // parametre variant de l'URL sur le palier par defaut et ne le met plus
      // a jour ensuite, et le champ cache name="id" reste lui aussi en arriere.
      var r = document.querySelector('[data-tt-variant] input[type="radio"]:checked');
      if (r && r.value) return String(r.value);
      try {
        var u = new URL(window.location.href).searchParams.get('variant');
        if (u) return String(u);
      } catch (e) {}
      var i = form && form.querySelector('[name="id"]');
      return i ? String(i.value) : '';
    }

    // Prix du pack en achat unique au-dessus du seuil : on privilegie le mois.
    function preferMonthly() {
      if (isNaN(monthlyFrom)) return false;
      var v = prices[variantId()];
      return !!(v && v.once != null && v.once > monthlyFrom);
    }

    // Place la frequence privilegiee a gauche (ordre du DOM, pour que la
    // tabulation suive l'ordre visuel) et la preselectionne tant que le
    // client n'a pas choisi lui-meme.
    function applyFreqPreference() {
      if (!plans.week || !plans.month) return;
      var preferred = preferMonthly() ? 'month' : 'week';
      if (freqOpts) {
        var first = freqOpts.querySelector('[data-ob-freq-val="' + preferred + '"]');
        if (first && freqOpts.firstElementChild !== first) {
          freqOpts.insertBefore(first, freqOpts.firstElementChild);
        }
      }
      if (!freqTouched) freq = preferred;
    }

    // Plan reellement soumis avec le formulaire : seul l'abonnement explicite
    // place un selling_plan. En achat unique comme tant que rien n'est choisi,
    // aucun plan n'est envoye.
    function currentPlanId() {
      return mode === 'sub' ? plans[freq] : '';
    }

    // Plan utilise pour l'AFFICHAGE des prix. L'abonnement choisi et l'etat
    // initial (rien de choisi) montrent tous deux le tarif remise ; seul
    // l'achat unique explicite revient au tarif plein.
    function pricingPlanId() {
      return mode === 'once' ? '' : plans[freq];
    }

    // Le script du bouton d'achat lit cet attribut en priorite pour composer
    // son libelle. Sans lui il afficherait le prix unitaire, donc un prix faux
    // des qu'un abonnement est choisi.
    function syncBuyLabel() {
      if (!buyWrap) return;
      // Prix d'affichage : remise tant qu'on n'est pas en achat unique.
      var v = prices[variantId()];
      var pid = pricingPlanId();
      var c = v && pid && v[pid] != null ? v[pid] : null;
      if (mode !== 'once' && c != null) {
        var card = document.querySelector('[data-tt-variant][data-variant-id="' + variantId() + '"]');
        var el = card && card.querySelector(PRICE_SEL);
        var sample = el ? (el.getAttribute('data-ob-orig') || el.textContent.trim()) : '';
        buyWrap.setAttribute('data-ob-sub-price', moneyLike(sample, c));
      } else {
        buyWrap.removeAttribute('data-ob-sub-price');
      }
      // Reveille le script du bouton d'achat, qui recompose alors son libelle.
      // C'est l'evenement qu'il ecoute ; un simple resize ne declenchait rien.
      try { document.dispatchEvent(new CustomEvent('tt:variant:change', { detail: { fromObSub: true } })); } catch (e) {}
    }

    function syncSubmitButton() {
      if (!form) return;
      var btn = form.querySelector('[type="submit"], button[name="add"]');
      if (!btn) return;
      // Verrou cooperatif : tant que le client n'a pas choisi un mode de
      // livraison, l'ajout au panier est bloque. Les verrous des autres blocs
      // (pseudo, videos...) restent respectes.
      if (mode === '') {
        btn.setAttribute('data-tt-block-obsub', '1');
      } else {
        btn.removeAttribute('data-tt-block-obsub');
      }
      var blocked = false;
      for (var i = 0; i < btn.attributes.length; i++) {
        if (btn.attributes[i].name.indexOf('data-tt-block-') === 0) { blocked = true; break; }
      }
      btn.disabled = blocked;
    }

    function render() {
      applyFreqPreference();

      root.querySelectorAll('[data-ob-mode]').forEach(function (b) {
        var on = b.getAttribute('data-ob-mode') === mode;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      root.querySelectorAll('[data-ob-freq-val]').forEach(function (b) {
        var on = b.getAttribute('data-ob-freq-val') === freq;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });

      if (freqWrap) freqWrap.hidden = mode !== 'sub';

      var pid = currentPlanId();
      if (planInput) {
        if (pid) {
          planInput.value = pid;
          planInput.disabled = false;
        } else {
          planInput.value = '';
          planInput.disabled = true; // absent de la requete : vente simple
        }
      }


      syncCardPrices();
      syncSavings();
      syncBuyLabel();
      syncSubmitButton();
    }

    root.querySelectorAll('[data-ob-mode]').forEach(function (b) {
      b.addEventListener('click', function () {
        mode = b.getAttribute('data-ob-mode');
        render();
      });
    });
    root.querySelectorAll('[data-ob-freq-val]').forEach(function (b) {
      b.addEventListener('click', function () {
        freq = b.getAttribute('data-ob-freq-val');
        freqTouched = true;
        render();
      });
    });

    // La variante change (selecteur de pack) : il faut relancer le rendu
    // complet, pas seulement le libelle du bouton, sinon les cartes restent
    // au tarif plein et le bouton garde le prix de la variante precedente.
    var pending = null;
    function refresh() {
      if (pending) clearTimeout(pending);
      // Court differe : le theme met a jour la variante sur le meme clic,
      // on passe apres lui plutot que de se faire ecraser.
      pending = setTimeout(function () { pending = null; render(); }, 70);
    }

    // Juste avant l'envoi au panier : le champ name="id" peut avoir pris du
    // retard sur le pack coche (ou etre vide), et Shopify repond alors
    // « Cannot find variant ». On le recale sur le pack reellement choisi,
    // ainsi que le plan d'abonnement, au dernier moment.
    function syncBeforeSubmit(e) {
      if (!form) return;
      // Filet de securite : aucun mode choisi => on bloque l'envoi au panier,
      // meme si le bouton a ete re-rendu par le theme entre-temps.
      if (mode === '') {
        if (e && e.type === 'submit' && e.cancelable) {
          e.preventDefault();
          e.stopPropagation();
        }
        syncSubmitButton();
        return;
      }
      var vid = variantId();
      if (vid && prices[vid]) {
        var idInput = form.querySelector('input[name="id"]');
        if (idInput) {
          idInput.disabled = false;
          if (idInput.value !== vid) idInput.value = vid;
        }
      }
      var pid = currentPlanId();
      if (planInput) {
        planInput.value = pid || '';
        planInput.disabled = !pid;
      }
    }

    if (form) {
      form.addEventListener('submit', syncBeforeSubmit, true);
      document.addEventListener('click', function (e) {
        var b = e.target && e.target.closest && e.target.closest('[type="submit"], button[name="add"]');
        if (b && (b.form === form || form.contains(b))) syncBeforeSubmit();
      }, true);
      form.addEventListener('change', refresh);
      var idInput = form.querySelector('[name="id"]');
      if (idInput && window.MutationObserver) {
        new MutationObserver(refresh).observe(idInput, { attributes: true, attributeFilter: ['value'] });
      }
      document.addEventListener('tt:variant:change', function (e) {
        // On ignore l'evenement que l'on emet nous-memes.
        if (e && e.detail && e.detail.fromObSub) return;
        refresh();
      });
      document.addEventListener('click', function (e) {
        var card = e.target && e.target.closest && e.target.closest('[data-tt-variant]');
        if (card) refresh();
      }, true);
      // Le theme met a jour l'URL sans rechargement lors d'un changement de
      // palier : on suit aussi ce signal.
      window.addEventListener('popstate', refresh);
    }

    render();
  }

  function boot() { document.querySelectorAll(SELECTOR).forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) {
    (e.target.querySelectorAll ? e.target : document).querySelectorAll(SELECTOR).forEach(init);
  });
})();
